
import { ScheduledClass } from '@/types/types';
import { getUserGymId } from '@/utils/gymAuth';
import { classesService } from '@/services/classesService';
import { deleteBooking } from '@/services/bookingsService';

/**
 * Fetch scheduled classes via classes-management edge function
 * Uses class_availability view for optimized queries with booking stats
 * 
 * @deprecated This function is kept for backward compatibility.
 * New code should use classesService.getScheduledClasses() directly.
 */
export const fetchScheduledClasses = async (
  startDate?: string,
  endDate?: string,
  userAllowedCourses?: string[] | null,
  calendarId?: string | null
): Promise<ScheduledClass[]> => {
  console.log('[fetchScheduledClasses] Calling classesService with:', {
    startDate: startDate || 'all',
    endDate: endDate || 'all',
    userAllowedCoursesCount: userAllowedCourses?.length,
    calendarId
  });

  try {
    const gymId = getUserGymId();

    if (!gymId) {
      console.error('[fetchScheduledClasses] gymId is undefined or null');
      throw new Error('gymId not available');
    }

    const classes = await classesService.getScheduledClasses(
      gymId,
      startDate,
      endDate,
      userAllowedCourses,
      calendarId
    );

    console.log(`[fetchScheduledClasses] Received ${classes.length} classes`);
    return classes;
  } catch (error) {
    console.error('[fetchScheduledClasses] Unexpected error:', error);
    throw error;
  }
};

/**
 * Delete booking via bookings-management edge function
 * Deletes both booking and associated attendance record
 * 
 * @deprecated This function is kept for backward compatibility.
 * New code should use deleteBooking from bookingsService directly.
 */
export const deleteBookingById = async (bookingId: string): Promise<boolean> => {
  console.log('[deleteBookingById] Calling deleteBooking with:', { bookingId });
  
  try {
    await deleteBooking(bookingId);
    console.log('[deleteBookingById] Success');
    return true;
  } catch (error) {
    console.error('[deleteBookingById] Error:', error);
    return false;
  }
};
